import { createHttpClient } from "./create-http-client";

const DEFAULT_BASE_URL = "https://dev-api.ifoodmateriais.com";
const REQUEST_TIMEOUT_MS = 10000;

const baseURL = process.env.VUE_APP_HOSTNAME || DEFAULT_BASE_URL;
const backendOrigin = baseURL.replace(/\/+$/, "");

const api = createHttpClient({
  baseURL,
  timeoutMs: REQUEST_TIMEOUT_MS,
  defaultHeaders: {
    "Content-Type": "application/json",
  },
  beforeRequest(config) {
    const token = sessionStorage.getItem("tokenLogin");
    // URL absoluta ignora a baseURL: não mandar o token do usuário para fora.
    if (token && config.url.startsWith(backendOrigin)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
});

/**
 * Hosts de terceiros (viacep, fleet-api, driver-api): sem baseURL, sem Authorization
 * e sem timeout.
 */
const httpExternal = createHttpClient({});

export { api, httpExternal };
export default api;
